import { create } from 'zustand';
import { shallow } from 'zustand/shallow';

type State = {
  phoneNumber: string;
};

type Actions = {
  setPhoneNumber: (phoneNumber: string) => void;
  resetPhoneNumber: () => void;
};

const initialState: State = {
  phoneNumber: null,
};

const useEditProfileStoreBase = create<State & Actions>()(set => ({
  ...initialState,
  setPhoneNumber: phoneNumber => set({ phoneNumber }),
  resetPhoneNumber: () => set(initialState),
}));

export const useEditProfileStore = <U>(
  selector: (state: State & Actions) => U
) => {
  return useEditProfileStoreBase(selector, shallow);
};
